import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap } from 'rxjs/operators';
import { toPayload } from '../../utils/rx-utils';
import { CompaniesReqDelSuccessAction, COMPANY_DEL_SUCCESS } from '../actions/companies';
import { COMPANY_DEL_INVITE_LINK_SUCCESS, CompanyReqDeleteInviteLinkSuccessAction } from '../actions/company-links';
import { CompaniesStoreService } from '../services/companies-store.service';

@Injectable()
export class CompaniesEffects {
  constructor(
    private actions$: Actions, //
    private companyStore: CompaniesStoreService,
  ) {}

  public deleteLink$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType<CompanyReqDeleteInviteLinkSuccessAction>(
          COMPANY_DEL_INVITE_LINK_SUCCESS, //
        ),
        map(toPayload),
        filter((req) => req.deleteUsers),
        switchMap((req) => {
          return this.companyStore.loadOne(req.companyId);
        }),
      );
    },
    { dispatch: false },
  );

  public deleteCompanies$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType<CompaniesReqDelSuccessAction>(
          COMPANY_DEL_SUCCESS, //
        ),
        map((action) => {
          return action.payload.moveToCompanyId;
        }),
        filter((companyId): companyId is string => {
          return !!companyId;
        }),
        switchMap((companyId) => {
          return this.companyStore.loadOne(companyId);
        }),
      );
    },
    { dispatch: false },
  );
}
